import { NativeStackHeaderProps, router, Stack } from 'expo-router';
import GetVaroApp from 'features/getVaroApp/GetVaroApp';
import React from 'react';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';

export default function GetVaroAppPage() {
  const handleBackButtonAction = () => {
    router.back();
  };

  return (
    <>
      <Stack.Screen
        options={{
          headerShown: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar
              {...props}
              primaryOnPress={handleBackButtonAction}
            />
          ),
        }}
      />
      <GetVaroApp />
    </>
  );
}
